import { useState } from 'react'
import { Trans } from 'react-i18next'

import { ColumnTypes } from '@makyoapp/makyo-sdk/models/Table'
import { FunctionItem } from '@makyoapp/makyo-common'
import { ChevronSmallDown } from '@makyoapp/makyo-icon/icon'

import { ColumnTypeIcon } from '@/components/ColumnTypeIcon'
import FieldDateTime from '@/components/GridV2/components/fields/FieldDateTime'
import FieldNumber from '@/components/GridV2/components/fields/FieldNumber'

interface Props {
  item: FunctionItem
  options?: Record<string, unknown>
}

export function FnFormat({ item, options }: Props) {
  const [open, setOpen] = useState(true)

  return [ColumnTypes.Number, ColumnTypes.DateTime].includes(item.returnType || ColumnTypes.Text) &&
    item.returnUnknown !== true ? (
    <div className='min-w-0 pt-4'>
      <div className='p-2 border bdr flex-c justify-between' onClick={() => setOpen(!open)}>
        <span className='font-bold flex-c'>
          <ColumnTypeIcon type={item.returnType || ColumnTypes.Text} />
          <Trans>Formatting Options</Trans>
        </span>
        <ChevronSmallDown className='shrink-0' />
      </div>
      {open && (
        <div className='p-2 border-b border-l border-r bdr'>
          {item.returnType === ColumnTypes.Number && <FieldNumber />}
          {item.returnType === ColumnTypes.DateTime && <FieldDateTime {...options} showTimezone={false} />}
        </div>
      )}
    </div>
  ) : null
}
